import { render, staticRenderFns } from "./SignInSecondFactor.vue?vue&type=template&id=3123e322&scoped=true"
import script from "./SignInSecondFactor.vue?vue&type=script&lang=ts"
export * from "./SignInSecondFactor.vue?vue&type=script&lang=ts"
import style0 from "./SignInSecondFactor.vue?vue&type=style&index=0&id=3123e322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123e322",
  null
  
)

export default component.exports